
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InquiryModal from './InquiryModal';
import Button from '../ui/Button';

// Completely replaced legacy CSS logic with direct Tailwind CSS since it's the final iteration.
const UnifiedInquirySection = ({ 
    title = '우리 비즈니스 현장에도 똑같이 적용될 수 있을까요?',
    buttonText = '💬 편하게 문의하기',
    buttonAction = 'CONTACT'
}) => {
    const navigate = useNavigate();
    const [modal, setModal] = useState({ isOpen: false, type: 'CONTACT' });

    const openModal = (type) => {
        setModal({ isOpen: true, type });
    };

    return (
        <section className="py-20 px-6 bg-gradient-to-br from-gray-50 to-white border-t border-gray-100 rounded-3xl my-8 shadow-sm max-w-6xl mx-auto">
            <InquiryModal
                isOpen={modal.isOpen}
                onClose={() => setModal(prev => ({ ...prev, isOpen: false }))}
                type={modal.type}
            />
            
            <div className="max-w-4xl mx-auto text-center">
                <h3 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6 tracking-tight break-keep">
                    {title}
                </h3>
                
                <p className="text-xl text-gray-600 mb-10 leading-relaxed break-keep">
                    고민하지 마세요. 우측 하단의 <strong className="text-primary-500 font-bold">스피드 다이얼(🚀)</strong>을 클릭해, 원하시는 맞춤형 플로우로 전문가의 세밀한 답변을 즉시 확인해 보실 수 있습니다.
                </p>
                
                <div className="flex justify-center">
                    <Button 
                        onClick={() => openModal(buttonAction)} 
                        variant="primary" 
                        size="md" 
                        className="text-[1.05rem] font-extrabold px-8 py-4 rounded-full shadow-glow flex items-center justify-center gap-2.5 transition-transform hover:-translate-y-1"
                    >
                        {buttonText}
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default UnifiedInquirySection;
